import React, { PureComponent } from 'react';
import { getCurrentUser } from '../../util/storage/accessTokenStorage';
import ApiConfig from '../../config/ApiConfig';
import AdminNavigation from '../partials/navigation/AdminNavigation';
import NoData from '../partials/empty_data/NoData';
import { logOutUser } from '../../actions/globalActions';
import BigLayout from '../../layouts/BigLayout';
import GeolocationUserDetailListItem from '../partials/list_items/GeolocationUserDetailListItem';
import BaseGeolocationUserDetail from '../../containers/base/BaseGeolocationUserDetail';

class GeolocationUserDetail extends PureComponent {
  validateAdminUser = (user) => {
    if(user.user.isAdmin !== 1) {
      this.props.dispatch(logOutUser(this.props.history));
    }
  };
  
  render() {
    const user = getCurrentUser();
    this.validateAdminUser(user);
    let endpoint = ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.getGeolocationForUser + this.props.match.params.id;
  
    return (
      <div>
        <AdminNavigation history={this.props.history} page="Home" />
        <BigLayout>
          <BaseGeolocationUserDetail
            endpoint={endpoint}
            id="geolocationUserDetail"
            noData={NoData}
            itemComponent={GeolocationUserDetailListItem}
          />
        </BigLayout>
      </div>
    )
  }
}

export default GeolocationUserDetail;
